import React, { Component } from "react";
import MazTuInfoBeesButton from "../../../components/maz-tu-info-bees/maz-tu-info-bees-button/MazTuInfoBeesButton";
import MazTuInfoBeesTitle from "../../../components/maz-tu-info-bees/maz-tu-info-bees-title/MazTuInfoBeesTitle";
import { getCookie } from '../../../utils/cookiesUtils';
import { getUser } from '../../../utils/sessionInfo';
import "./ThankYou.scss";

export default class ThankYou extends Component {

  state = {
    personaType: "fisica"
  }

  render() {
    let imageClass = "thank-you__container__logo";
    let decoded = null;
    try {
      const storedUserData = localStorage.getItem("@selectType");
      if (storedUserData) {
        decoded = JSON.parse(storedUserData);
        if (decoded.type === "mixto") {
          imageClass = "thank-you__container__logo_gold";
        }
      } else {
          const user = getCookie('userInfoBees') ?? getUser();

          if (user?.clubLevel === 'B_MAX') {
            imageClass = 'thank-you__container__logo_gold';
          }
      }
    } catch (e) {}
    return(
      <div className="thank-you">

        <MazTuInfoBeesTitle
          title="¡Gracias!"
          />

        <div className="thank-you__container">

          <div className={imageClass}></div>

          <div className="thank-you__container__title">
            ¡Tu solicitud ha sido<br />enviada exitosamente!
          </div>

          <div className="thank-you__container__text">
            La información está siendo revisada. Ingresa durante la semana para comprobar que se haya activado tu programa.
          </div>

        </div>

      </div>
    )
  }

}
